import React from "react";
import { TabItem } from "./TabItem";
import {
  TherapistTab1Image,
  TherapistTab2Image,
  TherapistTab3Image,
} from "../../../assets";

export const TherapistTab = () => {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mt-[44px] min-w-0">
      <TabItem
        title="Flexible Hours"
        description="Heros can choose their work hours, set their availability, and accept bookings according to their schedule, offering them freedom to work when they want."
        image={TherapistTab1Image}
        imgClassName="max-w-[280px] sm:max-w-[320px] mx-auto"
        variant="hero"
      />

      <TabItem
        title="Transparent Earnings"
        description="Heros receive secure payments, with clear visibility of their earnings, commission rates and transaction history."
        image={TherapistTab2Image}
        imgClassName="max-w-[300px] sm:max-w-[360px] mx-auto"
        variant="hero"
      />
      <TabItem
        title="Built-in Communication & Feedback"
        description="Heros can easily communicate with clients before sessions and receive valuable feedback, helping them improve their services and client relationships."
        image={TherapistTab3Image}
        centeredImage
        className="md:col-span-2 lg:col-span-1"
        imgClassName="max-w-[220px] sm:max-w-[260px] mx-auto"
        variant="hero"
      />
    </div>
  );
};
